import { render, staticRenderFns } from "./SyllabusCreateEdit.vue?vue&type=template&id=c0bb9d8a&scoped=true"
import script from "./SyllabusCreateEdit.vue?vue&type=script&lang=js"
export * from "./SyllabusCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./SyllabusCreateEdit.vue?vue&type=style&index=0&id=c0bb9d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb9d8a",
  null
  
)

export default component.exports